export default __webpack_public_path__ + "static/8-4--088a4125fb34b9879a48b9b696340389.png";